'use client'       
import { ReactNode, useState } from 'react';
import Form from 'react-bootstrap/Form';

    const THREEJSConfig = (props: any):ReactNode =>{

    const parallaxST = localStorage.getItem('parallax'); 
    const PPST =  localStorage.getItem('postProcessing');
    const raytracingST =  localStorage.getItem('rayTracing');
    const hdSkyboxST =  localStorage.getItem('hdSkybox');

    const parallax = parallaxST !== null ? parseInt(parallaxST) == 1?true : false : false; 
    const pp = PPST !== null ? parseInt(PPST) == 1?true : false : false; 
    const raytracing = raytracingST !== null ? parseInt(raytracingST) == 1?true : false : false; 
    const hdSkybox = hdSkyboxST !== null ? parseInt(hdSkyboxST) == 1?true : false : false; 

    

    const [parallaxState, setParallax] = useState(parallax);
    const [ppState, setPP] = useState(pp);
    const [raytracingState, setRaytracing] = useState(raytracing);
    const [hdSkyboxState, sethdSkybox] = useState(hdSkybox);

    

    return (
        <div>

            <Form className='engine-config' id="threejs-config">
                <Form.Check // prettier-ignore
                onChange={() => {
                    localStorage.setItem('parallax', parallaxState ? "0" : "1");
                    setParallax(!parallaxState);
                }}
                checked = {parallaxState}
                type="switch"
                
                id="threejs-parallax"
                label="ground FX"
                />
                <Form.Check // prettier-ignore
                    onChange={() => {
                        localStorage.setItem('postProcessing', ppState ? "0" : "1");
                        setPP(!ppState);
                    }}
                    checked = {ppState}
               
                    type="switch"
                    label="PP"
                    id="threejs-postprocessing"
                    
                />
                  <Form.Check // prettier-ignore
                    onChange={() => {
                        localStorage.setItem('rayTracing', raytracingState ? "0" : "1");
                        setRaytracing(!raytracingState);
                    }}
                    checked = {raytracingState}
                    type="switch"
                    label="RT"
                    id="threejs-raytracing"
                    
                />


                  <Form.Check // prettier-ignore
                    onChange={() => {
                        localStorage.setItem('hdSkybox', hdSkyboxState ? "0" : "1");
                        sethdSkybox(!hdSkyboxState);
                    }}
                    checked = {hdSkybox}
                    type="switch"
                    label="hdSkybox"
                    id="threejs-hdSkybox"
                    
                />
            </Form>

        </div>
    );
}
export default THREEJSConfig;
